import core from "@/helpers/client";
const groupService = {
  async headGroupAsync(applicationId, params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/groups?no-cache=1`,
      params
    );
    return result;
  },
  async getGroupsAsync(applicationId, params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/groups?no-cache=1`,
      params
    );
    return result;
  },
  async getGroupAsync(applicationId, id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/groups/${id}?no-cache=1`
    );
    return result;
  },
  async getGroupCrossPlatformAsync(applicationId, id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/groups/${id}/crossplatform?no-cache=1`
    );
    return result;
  },
  async createGroupAsync(applicationId, model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/groups`,
      model
    );
    return result;
  },
  async createGroupCrossPlatformAsync(applicationId, groupId, model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/groups/${groupId}/crossplatform`,model
    );
    return result;
  },
  async updateGroupAsync(applicationId, id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/groups/${id}`,
      model
    );
    return result;
  },
  async patchGroupAsync(applicationId, id, model) {
    const result = await core.edit(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/groups/${id}`, model 
    );
    return result;
  },
  async deleteGroupByIdAsync(applicationId, id) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/groups/${id}`
    );
    return result;
  },
  async deleteGroupUserByUserIdAsync(applicationId, id, userId) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/groups/${id}/users/${userId}`
    );
    return result;
  },
  async InviteEmployeeAsync(applicationId, groupId, model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/groups/${groupId}/invites/ad`,model
    );
    return result;
  },
  async InviteEmployeeByEmailAsync(applicationId, groupId, model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/groups/${groupId}/invites/ad`,model
    );
    return result;
  },
  async updateGroupCrossPlatformAsync(applicationId, groupId, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/groups/${groupId}/crossplatform`,model
    );
    return result;
  },
  async deleteGroupCrossPlatformAsync(applicationId, groupId, params) {
    const result = await core.remove(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/groups/${groupId}/crossplatform?${params}`
    );
    return result;
  }
};
export default groupService;
